import { render, staticRenderFns } from "./advertStatisticsReal.vue?vue&type=template&id=1708b15e&scoped=true&"
import script from "./advertStatisticsReal.vue?vue&type=script&lang=js&"
export * from "./advertStatisticsReal.vue?vue&type=script&lang=js&"
import style0 from "./advertStatisticsReal.vue?vue&type=style&index=0&id=1708b15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708b15e",
  null
  
)

export default component.exports